import { Component } from '@angular/core';
import { NavController, LoadingController, Events, ToastController } from 'ionic-angular';

import { Form } from '../../../providers/survey';

import { ListItemFaskerPage } from '../';
import { UserMyRadiant as User, TrackingAsset, TrackingFasker } from '../../../providers';


import { TabsPage } from '@pages/dashboard';

@Component({
  selector: 'page-list-form',
  templateUrl: 'index.html'
})
export class ListFormPage {

  list_form  : any= [];
  total_data : any;

  tracking_active = {
    id : 0
  };

  user_data  : any={};
  resp_data  : any=[];

  list_resp_personal        : any = [];
  list_resp_dept            : any = [];
  list_resp_edited_personal : any = [];
  list_resp_edited_dept     : any = [];
  list_resp_moved_personal  : any = [];
  list_resp_moved_dept      : any = [];

  fasker_personal_opnamed = 0;
  fasker_dept_opnamed = 0;

  server_date = {};

  loading : any;

  constructor(
    public  navCtrl       : NavController,
    public  loadingCtrl   : LoadingController,
    public  toastCtrl     : ToastController,
    public  formApi       : Form,
    public  trackingApi   : TrackingAsset,
    public  trackFaskerApi: TrackingFasker,
    public  userApi       : User,
    private events        : Events
  ) {
    this.user_data = this.userApi.data;

  }

  ionViewWillEnter(){
    this.getList();
    this.getTracking();
    // this.getListDataDept();/\
    this.getListDataPersonal();
  }

  showLoading(){
    this.loading = this.loadingCtrl.create({
      content : 'Please wait . . .'
    });
    this.loading.present();
  }
  doRefresh(refresher) {
    refresher.complete();
    this.getList();
  }
  presentToast(msg){
    this.toastCtrl.create({
      message: msg,
      duration: 3000,
      position: 'top'
    }).present();
  }

  getList(){
    this.showLoading();

    let params:any = {
      modul : 'opname'
    };
    this.formApi.get(params).subscribe((resp:any) => {
      console.log('getListForm =>',resp);
      if(resp.success){
        this.list_form  = resp.data;
        this.total_data = resp.total_rows;
      }

      this.loading.dismiss();
    },(err) => {
      console.log(err);
      this.loading.dismiss();
    });
  }

  getTracking(){
    let params = {
      status : 0
    }
    this.trackingApi.get(params).subscribe((resp : any) => {
      if(resp.success){
        this.tracking_active = resp.data[0];
      }
    });
  }

  getListDataDept(){
    let loading = this.loadingCtrl.create({
      content: 'Please wait...'
    });
    loading.present();

    let params = {
      user_id   : this.user_data.employee_id,
      form_id   : 9
    };

      this.trackFaskerApi.getItemTracking(params).subscribe((resp:any) => {
        if(resp.success){
            this.list_resp_dept = resp.data
            if(this.list_resp_dept.length > 0){
              this.fasker_dept_opnamed = 0
              this.list_resp_dept.forEach(rec => {
                if(rec.tracking_act != null && rec.tracking_act != ''){
                  this.fasker_dept_opnamed++
                }
              });
            }    
        }else{
          this.presentToast("Error while loading data !")
        }

        this.trackFaskerApi.getItemFaskerTracking(params).subscribe((resp:any) => {        
          let temp_data = [];
          if(resp.success){
            temp_data = resp.data;
            this.list_resp_edited_dept = [];
            this.list_resp_moved_dept = [];
            temp_data.forEach(rec => {
              if(rec.updated_by == this.user_data.employee_id && rec.tracking_act != null){
                  this.list_resp_edited_dept.push(rec);
                }
                if(rec.pj_id == this.user_data.employee_id && rec.pj_id != rec.updated_by && rec.tracking_act != null){
                  this.list_resp_moved_dept.push(rec);
                }
            });
          }else{
            this.presentToast("Error while loading data !")
          }
        }, (err) => {
               
        });

        loading.dismiss();
      }, (err) => {
        loading.dismiss();     
      });
  }
  getListDataPersonal(){
    let loading = this.loadingCtrl.create({
      content: 'Please wait...'
    });
    loading.present();

    let params = {
      user_id   : this.user_data.employee_id,
      form_id   : 7
    };

      this.trackFaskerApi.getItemTracking(params).subscribe((resp:any) => {
        if(resp.success){
            this.list_resp_personal = resp.data
            if(this.list_resp_personal.length > 0){
              this.fasker_personal_opnamed = 0
              this.list_resp_personal.forEach(rec => {
                if(rec.tracking_act != null && rec.tracking_act != ''){
                  this.fasker_personal_opnamed++
                }
              });
            }   
        }else{
          this.presentToast("Error while loading data !")
        }

        this.trackFaskerApi.getItemFaskerTracking(params).subscribe((resp:any) => {        
          let temp_data = [];
          if(resp.success){
            temp_data = resp.data;
            this.list_resp_moved_personal = [];
            this.list_resp_edited_personal = [];
            temp_data.forEach(rec => {
                if(rec.updated_by == this.user_data.employee_id && rec.tracking_act != null){
                  this.list_resp_edited_personal.push(rec);
                }
                if(rec.asset_user_id == this.user_data.employee_id && rec.asset_user_id != rec.updated_by && rec.tracking_act != null){
                  this.list_resp_moved_personal.push(rec);
                }
            });
          }else{
            this.presentToast("Error while loading data !")
          }
        }, (err) => {
               
        });

        loading.dismiss();
      }, (err) => {
        loading.dismiss();     
      });

  }

  toListResponse(item) {
    if(this.tracking_active.id > 0){
      this.navCtrl.push(ListItemFaskerPage, {
        form_id   : item.id,
        tracking  : this.tracking_active
      });
    }else{
      this.presentToast("Opname event not found !");
    }
  }

  // toForm(form){
  //   this.navCtrl.push(FormPage, {
  //     form : form
  //   });
  // }

  backMyRadiant(evt){
    this.navCtrl.setRoot(TabsPage,{tabIndex:1});
    this.events.publish('modul:myradiant');
  }

}



// WEBPACK FOOTER //
// ./src/pages/opname/list_form/index.ts